import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../services/api';
import { requestLaudoPresignDownload } from '../services/laudoFiles';

const DEFAULT_EXTENSIONS = ['.webm', '.pdf', '.mp4'];

const matchesExtension = (file, extensions) =>
  extensions.some(ext => file.Key.includes(ext));

const presignFiles = async (files, parallel) => {
  if (parallel) {
    return Promise.all(
      files.map(file =>
        requestLaudoPresignDownload({ key: file.Key }).then(url => ({
          url,
          ...file,
        }))
      )
    );
  }

  const resolved = [];
  for (const file of files) {
    const url = await requestLaudoPresignDownload({ key: file.Key });
    resolved.push({ url, ...file });
  }
  return resolved;
};

const useViewFiles = ({
  codLaudo,
  procedimento,
  extensions = DEFAULT_EXTENSIONS,
  parallel = false,
} = {}) => {
  const [urls, setURLs] = useState([]);
  const [loadingFiles, setLoadingFiles] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const loadFiles = useCallback(
    async ({ openModal = true, toastOnError = true } = {}) => {
      try {
        if (openModal) setShowModal(true);
        setLoadingFiles(true);

        const { data } = await api.get('/files', {
          params: { codLaudo, procedimento },
        });

        const filesToView = data.filter(item =>
          matchesExtension(item, extensions)
        );
        const resolved = await presignFiles(filesToView, parallel);

        setURLs(resolved);
      } catch (error) {
        setURLs([]);
        if (toastOnError) {
          toast.error(
            error?.response?.data?.error || 'Erro ao carregar imagens!'
          );
        }
      } finally {
        setLoadingFiles(false);
      }
    },
    [codLaudo, procedimento, extensions, parallel]
  );

  const showFiles = useCallback(() => loadFiles(), [loadFiles]);

  return {
    urls,
    setURLs,
    loadingFiles,
    showModal,
    setShowModal,
    showFiles,
    loadFiles,
  };
};

export default useViewFiles;
